import { Map } from "immutable";

import { ACTIONS } from "features/planner/planner.constants";
import { QualificationMapper } from "features/planner/planner.mappers";

const initialState = Map({});

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_QUALIFICATIONS: {
      if (error) return state;

      return Map(
        payload.map(Qualification => [
          Qualification.qualificationId.toString(),
          QualificationMapper.from(Qualification),
        ]),
      );
    }
    case ACTIONS.GET_QUALIFICATION:
    case ACTIONS.UPDATE_QUALIFICATION:
    case ACTIONS.CREATE_QUALIFICATION: {
      if (error) return state;

      return state.set(
        payload.qualificationId.toString(),
        QualificationMapper.from(payload),
      );
    }
    case ACTIONS.DELETE_QUALIFICATION: {
      if (error) return state;

      return state.delete(action.qualificationId.toString());
    }
    default:
      return state;
  }
};
